import React from 'react';
import FormGroups from '../form-groups/form-groups';

const FormGroupsPage = () => {
    return <FormGroups />;
};

export default FormGroupsPage;
